import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Tulvod - Ihr Experte fuer urbane Mobilitaet</title>
        <meta name="description" content="Tulvod - Entdecken Sie die besten Tipps, Routen und Informationen rund um Fahrradverleih und urbane Mobilitaet in Deutschland. Ihr Experte fuer Fahrradtouren und nachhaltige Fortbewegung." />
      </Helmet>

      <div className="policy-container">
      <h1>Rückerstattungsrichtlinie</h1>
      <p><strong>Letzte Aktualisierung:</strong> {new Date().toLocaleDateString('de-DE')}</p>

      <section>
        <h2>1. Allgemeine Informationen</h2>
        <p>
          Diese Rückerstattungsrichtlinie gilt für alle Dienstleistungen und Produkte, die über die Website 
          tulvod-de.com angeboten werden. Sie informiert über die Bedingungen und Verfahren für 
          Rückerstattungen und Stornierungen.
        </p>
        <p>
          Anbieter:<br />
          Fahrradverleih Service<br />
          Ederring 7<br />
          01775 Starnberg<br />
          Deutschland<br />
          E-Mail: tulvod@hotmail.com<br />
          Telefon: +4990874455288
        </p>
      </section>

      <section>
        <h2>2. Kostenlose Dienste</h2>
        <h3>2.1 Informationsangebot</h3>
        <p>
          Die Nutzung unserer Website und der bereitgestellten Informationen über Fahrradverleih, 
          Fahrradtouren und urbane Mobilität ist grundsätzlich kostenfrei. Da hierfür keine Gebühren erhoben 
          werden, entfällt auch die Möglichkeit einer Rückerstattung.
        </p>

        <h3>2.2 Newsletter</h3>
        <p>
          Die Anmeldung zu unserem Newsletter ist kostenfrei und kann jederzeit durch den Nutzer über den 
          in jeder E-Mail enthaltenen Abmeldelink beendet werden. Eine Rückerstattung ist nicht relevant, 
          da keine Kosten anfallen.
        </p>
      </section>

      <section>
        <h2>3. Kostenpflichtige Dienstleistungen (falls zutreffend)</h2>
        <h3>3.1 Widerrufsrecht für Verbraucher</h3>
        <p>
          Verbrauchern steht gemäß § 312g BGB in Verbindung mit § 355 BGB ein Widerrufsrecht zu. Sie haben 
          das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
        </p>
        <p>
          Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses. Um Ihr Widerrufsrecht 
          auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter 
          Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
        </p>

        <h3>3.2 Widerrufsformular</h3>
        <p>
          Sie können das folgende Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist:
        </p>
        <div style={{ padding: '15px', backgroundColor: '#f5f5f5', margin: '15px 0', borderRadius: '5px' }}>
          <p><strong>Muster-Widerrufsformular</strong></p>
          <p>
            An:<br />
            Fahrradverleih Service<br />
            Ederring 7<br />
            01775 Starnberg<br />
            E-Mail: tulvod@hotmail.com
          </p>
          <p>
            Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der 
            folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)
          </p>
          <p>
            Bestellt am (*)/erhalten am (*)<br />
            Name des/der Verbraucher(s)<br />
            Anschrift des/der Verbraucher(s)<br />
            Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)<br />
            Datum
          </p>
          <p>(*) Unzutreffendes streichen</p>
        </div>

        <h3>3.3 Folgen des Widerrufs</h3>
        <p>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten 
          haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus 
          ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste 
          Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag 
          zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
        </p>
        <p>
          Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen 
          Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; 
          in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>
      </section>

      <section>
        <h2>4. Ausnahmen vom Widerrufsrecht</h2>
        <p>
          Das Widerrufsrecht besteht nicht bei folgenden Verträgen:
        </p>
        <ul>
          <li>
            Verträge zur Lieferung von Waren, die nicht vorgefertigt sind und für deren Herstellung eine 
            individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist oder die eindeutig 
            auf die persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind
          </li>
          <li>
            Verträge zur Lieferung versiegelter Waren, die aus Gründen des Gesundheitsschutzes oder der 
            Hygiene nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde
          </li>
          <li>
            Verträge zur Erbringung von Dienstleistungen, wenn der Unternehmer diese vollständig erbracht 
            hat und mit der Ausführung der Dienstleistung erst begonnen hat, nachdem der Verbraucher dazu 
            seine ausdrückliche Zustimmung gegeben hat und gleichzeitig seine Kenntnis davon bestätigt hat, 
            dass er sein Widerrufsrecht bei vollständiger Vertragserfüllung verliert
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Rückerstattungsverfahren</h2>
        <h3>5.1 Antragstellung</h3>
        <p>
          Um eine Rückerstattung zu beantragen, kontaktieren Sie uns bitte:
        </p>
        <ul>
          <li>Per E-Mail: tulvod@hotmail.com</li>
            <li><a href="https://wa.me/4990874455288">WhatsApp</a></li>
            <li><a href="https://viber.me/4990874455288">Viber</a></li>
          <li>Per Telefon: +4990874455288</li>
          <li>Per Post: Ederring 7, 01775 Starnberg, Deutschland</li>
        </ul>
        <p>
          Bitte geben Sie dabei folgende Informationen an:
        </p>
        <ul>
          <li>Name und Kontaktdaten</li>
          <li>Bestellnummer oder Buchungsnummer</li>
          <li>Datum der Bestellung/Buchung</li>
          <li>Grund für die Rückerstattungsanfrage</li>
          <li>Gewünschte Zahlungsmethode für die Rückerstattung</li>
        </ul>

        <h3>5.2 Bearbeitungszeit</h3>
        <p>
          Rückerstattungsanträge werden in der Regel innerhalb von 5-7 Werktagen bearbeitet. Nach Genehmigung 
          Ihres Antrags erfolgt die Rückerstattung innerhalb von 14 Tagen auf das ursprüngliche 
          Zahlungsmittel.
        </p>

        <h3>5.3 Prüfung des Antrags</h3>
        <p>
          Wir behalten uns das Recht vor, jeden Rückerstattungsantrag zu prüfen. In einigen Fällen können 
          wir zusätzliche Informationen oder Nachweise anfordern, bevor eine Rückerstattung genehmigt wird.
        </p>
      </section>

      <section>
        <h2>6. Teilweise Rückerstattungen</h2>
        <p>
          In bestimmten Fällen können nur teilweise Rückerstattungen gewährt werden:
        </p>
        <ul>
          <li>Bei teilweise genutzten Dienstleistungen</li>
          <li>Bei Stornierungen außerhalb der festgelegten Fristen</li>
          <li>Bei beschädigten oder unvollständigen Rückgaben (falls zutreffend)</li>
          <li>Bei Sonderangeboten oder reduzierten Leistungen mit besonderen Bedingungen</li>
        </ul>
        <p>
          Die Höhe der teilweisen Rückerstattung wird individuell nach den Umständen des Einzelfalls festgelegt.
        </p>
      </section>

      <section>
        <h2>7. Keine Rückerstattung</h2>
        <p>
          Eine Rückerstattung ist in folgenden Fällen nicht möglich:
        </p>
        <ul>
          <li>Bei kostenfreien Dienstleistungen und Informationsangeboten</li>
          <li>Nach Ablauf der Widerrufsfrist von 14 Tagen (sofern keine anderen Gründe vorliegen)</li>
          <li>Bei vollständig erbrachten Dienstleistungen mit vorheriger ausdrücklicher Zustimmung</li>
          <li>Bei Verstoß gegen unsere Allgemeinen Geschäftsbedingungen</li>
          <li>Bei missbräuchlicher Nutzung unserer Dienstleistungen</li>
        </ul>
      </section>

      <section>
        <h2>8. Stornierungen</h2>
        <h3>8.1 Stornierung durch den Kunden</h3>
        <p>
          Kunden können Buchungen oder Bestellungen gemäß den jeweils geltenden Stornierungsbedingungen 
          stornieren. Die konkreten Stornierungsfristen und -bedingungen werden bei jeder Buchung bzw. 
          Bestellung gesondert mitgeteilt.
        </p>

        <h3>8.2 Stornierung durch den Anbieter</h3>
        <p>
          Wir behalten uns das Recht vor, Buchungen oder Bestellungen zu stornieren in Fällen von:
        </p>
        <ul>
          <li>Höherer Gewalt</li>
          <li>Technischen Problemen</li>
          <li>Fehlerhaften Preisangaben</li>
          <li>Nichtverfügbarkeit der Leistung</li>
          <li>Verdacht auf Betrug oder Missbrauch</li>
        </ul>
        <p>
          Bei Stornierung durch den Anbieter werden bereits geleistete Zahlungen vollständig zurückerstattet.
        </p>
      </section>

      <section>
        <h2>9. Zahlungsmethoden für Rückerstattungen</h2>
        <p>
          Rückerstattungen werden grundsätzlich über die ursprüngliche Zahlungsmethode abgewickelt:
        </p>
        <ul>
          <li><strong>Kreditkarte:</strong> Rückerstattung auf die verwendete Kreditkarte (5-10 Werktage)</li>
          <li><strong>PayPal:</strong> Rückerstattung auf das PayPal-Konto (3-5 Werktage)</li>
          <li><strong>Überweisung:</strong> Rückerstattung auf das angegebene Bankkonto (5-7 Werktage)</li>
          <li><strong>Andere Methoden:</strong> Nach individueller Vereinbarung</li>
        </ul>
        <p>
          Die angegebenen Zeiträume sind Richtwerte. Die tatsächliche Dauer kann je nach Bank oder 
          Zahlungsdienstleister variieren.
        </p>
      </section>

      <section>
        <h2>10. Beschwerdeverfahren</h2>
        <p>
          Falls Sie mit der Bearbeitung Ihrer Rückerstattungsanfrage nicht zufrieden sind, können Sie:
        </p>
        <ul>
          <li>Eine schriftliche Beschwerde an unsere Kundenservice-Abteilung richten</li>
          <li>Die europäische Online-Streitbeilegungsplattform nutzen: https://ec.europa.eu/consumers/odr</li>
          <li>Sich an eine Verbraucherschlichtungsstelle wenden</li>
          <li>Rechtliche Schritte einleiten</li>
        </ul>
        <p>
          Wir sind bestrebt, alle Beschwerden fair und zeitnah zu bearbeiten und eine zufriedenstellende 
          Lösung zu finden.
        </p>
      </section>

      <section>
        <h2>11. Änderungen dieser Richtlinie</h2>
        <p>
          Wir behalten uns das Recht vor, diese Rückerstattungsrichtlinie jederzeit zu ändern oder zu 
          aktualisieren. Änderungen werden auf dieser Seite veröffentlicht und treten mit der Veröffentlichung 
          in Kraft. Das Datum der letzten Aktualisierung wird am Anfang dieser Richtlinie angegeben.
        </p>
        <p>
          Für bereits abgeschlossene Verträge gilt die zum Zeitpunkt des Vertragsabschlusses gültige Fassung 
          der Rückerstattungsrichtlinie.
        </p>
      </section>

      <section>
        <h2>12. Kontakt</h2>
        <p>
          Bei Fragen zur Rückerstattungsrichtlinie oder bei Rückerstattungsanfragen wenden Sie sich bitte an:
        </p>
        <p>
          <strong>Kundenservice:</strong><br />
          Fahrradverleih Service<br />
          Ederring 7<br />
          01775 Starnberg<br />
          Deutschland
        </p>
        <p>
          <strong>E-Mail:</strong> tulvod@hotmail.com<br />
          <strong>Telefon:</strong> +4990874455288<br />
          <strong>Öffnungszeiten:</strong> Montag bis Freitag, 9:00 - 17:00 Uhr
        </p>
        <p>
          Wir bemühen uns, alle Anfragen innerhalb von 24-48 Stunden zu beantworten.
        </p>
      </section>

      <section>
        <h2>13. Verbraucherschutz</h2>
        <p>
          Diese Rückerstattungsrichtlinie berührt nicht Ihre gesetzlichen Rechte als Verbraucher. 
          Insbesondere bleiben Ihre Rechte aus Gewährleistung, Produkthaftung und anderen verbraucherschützenden 
          Vorschriften unberührt.
        </p>
        <p>
          Im Falle von Widersprüchen zwischen dieser Richtlinie und zwingenden gesetzlichen Bestimmungen 
          haben die gesetzlichen Bestimmungen Vorrang.
        </p>
      </section>
    </div>
  
    </>);
};

export default RefundPolicy;